module.exports = __webpack_public_path__ + "static/media/Сафонова Т..e0ebf353.pdf";